import { render } from "./AdminRiderraterangeCreate.vue?vue&type=template&id=7863a1c2&scoped=true&ts=true&lang=true"
import script from "./AdminRiderraterangeCreate.vue?vue&type=script&lang=ts"
export * from "./AdminRiderraterangeCreate.vue?vue&type=script&lang=ts"

import "./AdminRiderraterangeCreate.vue?vue&type=style&index=0&id=7863a1c2&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7863a1c2"]])

export default __exports__